import { Injectable, TemplateRef } from '@angular/core';

export enum TemplateType {
  Backup = 'backup',
  Delete = 'delete',
  Export = 'export',
  Restore = 'restore'
}

@Injectable({ providedIn: 'root' })
export class TemplateRegistryService {
  private templates = new Map<TemplateType, TemplateRef<unknown>>();

  registerTemplate(key: TemplateType, template: TemplateRef<unknown>): void {
    this.templates.set(key, template);
  }

  getTemplate(key: TemplateType): TemplateRef<unknown> | null {
    return this.templates.get(key) || null;
  }
}
